import { render, staticRenderFns } from "./getGiftDetails.vue?vue&type=template&id=69a90f98&scoped=true&"
import script from "./getGiftDetails.vue?vue&type=script&lang=js&"
export * from "./getGiftDetails.vue?vue&type=script&lang=js&"
import style0 from "./getGiftDetails.vue?vue&type=style&index=0&id=69a90f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a90f98",
  null
  
)

export default component.exports